// John Eldhose 20180530
import React, { Component } from 'react';
import { Checkbox, Paper, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { subscription } from '../../Api/subscription';

class Communications extends Component {
  state = {
    subscription: false
  };
  componentWillMount() {
    subscription('')
      .then((subsc) => {
        if(subsc.status === 'true')
          this.setState({ subscription: (subsc.data.subscription === 'true') });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleSubscription = (e) => {
    subscription('' + e.target.checked)
      .then((subsc) => {
        if(subsc.status === 'true' && subsc.data.changed === 1)
          this.setState({ subscription: (subsc.data.subscription === 'true') });
      })
      .catch((error) => {
        console.log(error);
      })
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>
            <FormattedMessage
              id='Communications'
              defaultMessage='Communications'
            />
          </font></center>
        </Typography>
        <p />
        <Paper style={{ padding: '25px' }}>
          <FormattedMessage
            id='Subscribe Carlson Newsletter'
            defaultMessage='Subscribe Carlson Newsletter'
          />
          <Checkbox
            checked={this.state.subscription}
            onChange={this.handleSubscription}
            value="checkedB"
            color="primary"
          /><br />
          <i>
            <FormattedMessage
              id='Subsciption Status'
              defaultMessage='Subsciption Status'
            />: {
              this.state.subscription ? (
                <FormattedMessage
                  id='Subscribed'
                  defaultMessage='Subscribed'
                />
              ) : (
                <FormattedMessage
                  id='Unsubscribed'
                  defaultMessage='Unsubscribed'
                />
              )
            }
          </i>
        </Paper>
        <br />
        <div style={{ textAlign: 'left', paddingLeft: '20px' }}>
          <Typography variant='caption'>
            Carlson Software sends out monthly newsletters with news of products and releases, hints from our tech support guys, special deals, info on upcoming webinars and seminars, intros to select staff and more. In order to comply with the General Data Protection Regulation ("GDPR") requirements and <a href="http://www.carlsonsw.com/about/privacy/">our privacy policy</a>, please confirm that you would like to receive Carlson Software newsletters with the toggle above! (You may unsubscribe at anytime)
          </Typography>
        </div>
      </div>
    );
  }

}

export default Communications;



// WEBPACK FOOTER //
// ./src/components/home/Communications.js